import { Typography } from '@mui/material';
import {
    Timeline,
    TimelineItem,
    TimelineSeparator,
    TimelineOppositeContent,
    TimelineDot,
    TimelineConnector,
    TimelineContent,
} from '@mui/lab';
import { useStyles } from './styles/CutTimeline.styles';

import type { ComponentProps, ReactNode } from 'react';

type CutTimelineProps = {
    items: {
        content: string;
        label: string;
        description?: ReactNode;
        icon?: ReactNode;
        color?: ComponentProps<typeof TimelineDot>['color'];
    }[];
};

export const CutTimeline = ({ items }: CutTimelineProps) => {
    const classes = useStyles();

    return (
        <Timeline>
            {items.map(({ content, label, icon, description, color }, index) => {
                return (
                    <TimelineItem key={`timeline-${content}-${label}`}>
                        <TimelineOppositeContent className={classes.leftContent}>
                            <Typography>{content}</Typography>
                        </TimelineOppositeContent>
                        <TimelineSeparator>
                            <TimelineDot color={color}>{icon && icon}</TimelineDot>
                            {index !== items.length - 1 && <TimelineConnector />}
                        </TimelineSeparator>
                        <TimelineContent className={classes.rightContent}>
                            <Typography fontWeight='bold'>
                                {label}
                                {description ? ':' : ''}
                            </Typography>
                            {typeof description !== 'string' ? description : <Typography>{description}</Typography>}
                        </TimelineContent>
                    </TimelineItem>
                );
            })}
        </Timeline>
    );
};
